import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onBeforeUnmount, ref } from 'vue';

import Select from '@/components/ui/select/Select.vue';
import type { SelectOption } from '@/components/ui/select/Select';
import { applyDataTablesPageLength } from '@/modules/shipments/utils/data-tables-page-length';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTablesLengthSelect',
  props: {
    select: {},
    options: {}
  },
  setup(__props: any) {

const props = __props;

const modelValue = ref(props.select.value);
const selectRef = ref<InstanceType<typeof Select> | null>(null);

function syncFromNativeSelect(): void {
  modelValue.value = props.select.value;
}

props.select.addEventListener('change', syncFromNativeSelect);

onBeforeUnmount(() => {
  props.select.removeEventListener('change', syncFromNativeSelect);
});

function handleUpdate(value: string): void {
  selectRef.value?.forceCloseMenu();
  modelValue.value = value;

  void nextTick(() => {
    if (!applyDataTablesPageLength(props.select, value) && props.select.value !== value) {
      props.select.value = value;
      props.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Select, {
    ref_key: "selectRef",
    ref: selectRef,
    "model-value": modelValue.value,
    options: __props.options,
    compact: "",
    "aria-label": "Rows per page",
    "onUpdate:modelValue": handleUpdate
  }, null, 8 /* PROPS */, ["model-value", "options"]))
}
}

})